export default __webpack_public_path__ + "c98cad7d5e90accc693af6424db15fe2.png";